import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import translate from "@/i18n/translate";
import { formatNumber, getPercentage } from "../../../src/static/js/commons";
import WidgetLoader from "../common/elements/WidgetLoader";
import ApiError from "../common/elements/ApiError";
export interface TermPersistenceRiskProps {
  highRiskTermPersistence: number;
  mediumRiskTermPersistence: number;
  lowRiskTermPersistence: number;
  notIndicatedRiskTermPersistence: number;
  highRiskTermPersistenceEngagement: number;
  lowRiskTermPersistenceEngagement: number;
  mediumRiskTermPersistenceEngagement: number;
  notIndicatedRiskTermPersistenceEngagement: number;
  loader: boolean;
  termSummaryFailed: boolean;
}

export default function TermPersistenceRisk({
  highRiskTermPersistence,
  mediumRiskTermPersistence,
  lowRiskTermPersistence,
  notIndicatedRiskTermPersistence,
  highRiskTermPersistenceEngagement,
  lowRiskTermPersistenceEngagement,
  mediumRiskTermPersistenceEngagement,
  notIndicatedRiskTermPersistenceEngagement,
  loader,
  termSummaryFailed
}: TermPersistenceRiskProps) {
  const [lowRiskTermPopoverState, setLowRiskPopoverState] = useState(false);
  const [mediumRiskTermPopoverState, setMediumRiskPopoverState] =
    useState(false);
  const [highRiskTermPopoverState, setHighRiskPopoverState] = useState(false);
  const [notIndicatedTermPopoverState, setNotIndicatedPopoverState] =
    useState(false);

  let arrOfRiskBarVal = [
    Number(lowRiskTermPersistenceEngagement),
    Number(mediumRiskTermPersistenceEngagement),
    Number(highRiskTermPersistenceEngagement),
    Number(notIndicatedRiskTermPersistenceEngagement)
  ];
  const largestTermPersistenceRiskValue = Math.max(...arrOfRiskBarVal);

  const lowRiskCourseEnga = getPercentage(
    lowRiskTermPersistenceEngagement,
    largestTermPersistenceRiskValue
  );

  const mediumRiskCourseEnga = getPercentage(
    mediumRiskTermPersistenceEngagement,
    largestTermPersistenceRiskValue
  );

  const highRiskCourseEnga = getPercentage(
    highRiskTermPersistenceEngagement,
    largestTermPersistenceRiskValue
  );

  const notIndicatedRiskCourseEnga = getPercentage(
    notIndicatedRiskTermPersistenceEngagement,
    largestTermPersistenceRiskValue
  );

  useEffect(() => {
    var lowRiskBtn = document.getElementById("low-risk-term");
    lowRiskBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === lowRiskBtn) {
        setLowRiskPopoverState(!lowRiskTermPopoverState);
      }
    });
  }, [lowRiskTermPopoverState]);

  useEffect(() => {
    var mediumRiskBtn = document.getElementById("medium-risk-term");
    mediumRiskBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === mediumRiskBtn) {
        setMediumRiskPopoverState(!mediumRiskTermPopoverState);
      }
    });
  }, [mediumRiskTermPopoverState]);

  useEffect(() => {
    var highRiskBtn = document.getElementById("high-risk-term");
    highRiskBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === highRiskBtn) {
        setHighRiskPopoverState(!highRiskTermPopoverState);
      }
    });
  }, [highRiskTermPopoverState]);

  useEffect(() => {
    var notIndicatedBtn = document.getElementById("not-indicated-term");
    notIndicatedBtn?.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && document.activeElement === notIndicatedBtn) {
        setNotIndicatedPopoverState(!notIndicatedTermPopoverState);
      }
    });
  }, [notIndicatedTermPopoverState]);

  function useClosePopoverOutsideClick(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLowRiskPopoverState(false);
          setHighRiskPopoverState(false);
          setMediumRiskPopoverState(false);
          setNotIndicatedPopoverState(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const riskSummaryLabel = useIntl().formatMessage({
    id: "app.sse.TermPersistenceriskSummaryLabel"
  });

  const lowRiskLabel = useIntl().formatMessage({
    id: "app.sse.lowRiskLabel"
  });

  const mediumRiskLabel = useIntl().formatMessage({
    id: "app.sse.mediumRiskLabel"
  });
  const highRiskLabel = useIntl().formatMessage({
    id: "app.sse.highRiskLabel"
  });
  const notIndicatedLabel = useIntl().formatMessage({
    id: "app.sse.notIndicatedLabel"
  });
  const riskSummaryLowRiskText = useIntl().formatMessage({
    id: "app.sse.riskSummaryTermLowRiskText"
  });
  const riskSummaryMediumRiskText = useIntl().formatMessage({
    id: "app.sse.riskSummaryTermMediumRiskText"
  });
  const riskSummaryHighRiskText = useIntl().formatMessage({
    id: "app.sse.riskSummaryTermHighRiskText"
  });
  const riskSummaryNotIndicatedText = useIntl().formatMessage({
    id: "app.sse.riskSummaryTermNotIndicatedText"
  });

  const keyEngagementRiskLevel = useIntl().formatMessage({
    id: "app.sse.keyEngagementRiskLevel"
  });

  const notIndicatedPopover = useIntl().formatMessage({
    id: "app.sse.notIndicatedPopover"
  });

  const highRiskPopover = useIntl().formatMessage({
    id: "app.sse.highRiskPopover"
  });

  const mediumRiskPopover = useIntl().formatMessage({
    id: "app.sse.mediumRiskPopover"
  });

  const lowRiskPopover = useIntl().formatMessage({
    id: "app.sse.lowRiskPopover"
  });

  const wrapperRef = useRef(null);
  useClosePopoverOutsideClick(wrapperRef);

  const TermPersistenceRiskBody = () => {
    return (
      <div className="body">
        <div className="wm-grid">
          <div className="course-completion-conatiner wm-grid-row">
            <div
              id="risk-summary-term"
              className="risk-summary wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8"
            >
              <div className="risk-summary-label">
                {translate("app.sse.termPersistenceLabel")}
              </div>
              <WmChart
                id="risk-summary-chart-term"
                chartType="doughnut2"
                label={riskSummaryLabel}
                valueFormat="amount"
                key="risk-summary-char-term"
                className="risk-summary-chart"
                print-mode={true}
              >
                <WmChartSlice
                  amount={String(lowRiskTermPersistence)}
                  legend={lowRiskLabel}
                  popoverTitle={formatNumber(lowRiskTermPersistence)}
                  popoverText={riskSummaryLowRiskText}
                ></WmChartSlice>
                <WmChartSlice
                  amount={String(mediumRiskTermPersistence)}
                  legend={mediumRiskLabel}
                  popoverTitle={formatNumber(mediumRiskTermPersistence)}
                  popoverText={riskSummaryMediumRiskText}
                ></WmChartSlice>
                <WmChartSlice
                  amount={String(highRiskTermPersistence)}
                  legend={highRiskLabel}
                  popoverTitle={formatNumber(highRiskTermPersistence)}
                  popoverText={riskSummaryHighRiskText}
                ></WmChartSlice>
                <WmChartSlice
                  amount={String(notIndicatedRiskTermPersistence)}
                  legend={notIndicatedLabel}
                  popoverTitle={formatNumber(notIndicatedRiskTermPersistence)}
                  popoverText={riskSummaryNotIndicatedText}
                ></WmChartSlice>
              </WmChart>
            </div>
            <div
              id="key-engagement-term"
              className="key-engagement wm-grid-col-6 wm-grid-col-md-5 wm-grid-col-sm-8"
            >
              <WmChart
                chartType="bar7"
                label={keyEngagementRiskLevel}
                showLegend={false}
                showBarLegend={true}
                labelWidth="95px"
                valueFormat="percentage"
                key="term-persistence-engagment-chart"
                print-mode={true}
              >
                <WmChartSlice
                  amount={formatNumber(lowRiskCourseEnga)}
                  legend={lowRiskLabel}
                  popoverTitle={formatNumber(lowRiskTermPersistenceEngagement)}
                  popoverText={lowRiskPopover}
                ></WmChartSlice>
                <WmChartSlice
                  amount={formatNumber(mediumRiskCourseEnga)}
                  legend={mediumRiskLabel}
                  popoverTitle={formatNumber(
                    mediumRiskTermPersistenceEngagement
                  )}
                  popoverText={mediumRiskPopover}
                ></WmChartSlice>
                <WmChartSlice
                  amount={formatNumber(highRiskCourseEnga)}
                  legend={highRiskLabel}
                  popoverTitle={formatNumber(highRiskTermPersistenceEngagement)}
                  popoverText={highRiskPopover}
                ></WmChartSlice>
                <WmChartSlice
                  amount={formatNumber(notIndicatedRiskCourseEnga)}
                  legend={notIndicatedLabel}
                  popoverTitle={formatNumber(
                    notIndicatedRiskTermPersistenceEngagement
                  )}
                  popoverText={notIndicatedPopover}
                ></WmChartSlice>
              </WmChart>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="wm-grid-col-12">
      <div className="paper-card paper-card-height">
        <div className="header">
          <div className="info">
            <h3 className="title">
              {translate("app.sse.termPersistenceRiskTitle")}
            </h3>
            <p className="description -descs">
              {translate("app.sse.understandTheTerms")}
            </p>
          </div>
        </div>
        {loader && (
          <WidgetLoader
            loaderContainerClasses="loader"
            loaderClasses="content"
          />
        )}
        {!loader && !termSummaryFailed && <TermPersistenceRiskBody />}

        {termSummaryFailed && <ApiError />}
      </div>
    </div>
  );
}
